import React, { createContext, useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-hot-toast';
import { isAccessTokenValid, clearTokens } from '../controllers/AuthController';
import { getUserByID } from '../controllers/UserController';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const updateAuth = (userData) => {
        setAuth(userData);
    };
    
    useEffect(() => {
        const refreshToken = Cookies.get('refresh');
        if (!refreshToken) {
            clearTokens();
            setLoading(false);
            return;
        };
        
        const fetchUserData = async () => {
            try {
                const token = await isAccessTokenValid();
                const { id } = jwtDecode(token);
                const userData = await getUserByID(id);
                setAuth(userData);
            } catch (error) {
                if (error.message.includes('role has been updated')) {
                    clearTokens();
                    window.location.href = '/';
                } else {
                    toast.error('Failed to fetch user data');
                };
            } finally {
                setLoading(false);
            };
        };
        
        fetchUserData();
    }, []);
    
    return (
        <AuthContext.Provider value={{ auth, loading, updateAuth }}>
            {children}
        </AuthContext.Provider>
    );
};
